"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TargetLink = function TargetLink(props) {

  if (!props.renderIf) return _react2.default.createElement(
    "div",
    null,
    props.children
  );

  return _react2.default.createElement(
    "a",
    {
      href: props.href,
      target: "_blank",
      rel: "noopener noreferrer"
    },
    props.children
  );
};

exports.default = TargetLink;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/target-link/index.js
 ** module id = 2586
 ** module chunks = 0
 **/